export const superAdminNavItems = [
    { path: "/", label: "Dashboard", permission: "dashboard" },
    { path: "/accounts", label: "Accounts", permission: "accounts:manage" },
    { path: "/leads", label: "Leads", permission: "leads:view" },
    { path: "/kanban", label: "Kanban", permission: "leads:manage" },
    { path: "/projects", label: "Projects", permission: "projects:view" },
    { path: "/support/dashboard", label: "Support", permission: "support:manage" },
    { path: "/variants", label: "Variants", permission: "variants:view" },
    { path: "/ai-providers", label: "AI Providers", permission: "platform-jobs:manage" },
    { path: "/settings", label: "Settings", permission: "settings:manage" },
    { path: "/system-logs", label: "System Logs", permission: "system-logs:view" },
    { path: "/system-jobs", label: "System Jobs", permission: "platform-jobs:manage" },
    { path: "/vertical-seeds", label: "Vertical Seeds", permission: "seeds:manage" },
    { path: "/demo-showcase", label: "Demo Showcase", permission: "platform-jobs:manage" },
    { path: "/knowledge-base", label: "Knowledge Base", permission: "system-logs:view" },
];

export const agencyNavItems = [
    { path: "/", label: "Dashboard", permission: "dashboard" },
    { path: "/accounts", label: "Clients", permission: "accounts:view" },
    { path: "/leads", label: "Leads", permission: "leads:view" },
    { path: "/projects", label: "Projects", permission: "projects:view" },
    { path: "/support/dashboard", label: "Support", permission: "support:view" },
    { path: "/settings", label: "Settings", permission: "settings:view" },
    { path: "/knowledge-base", label: "Help Center", permission: "support:view" },
];

export const clientNavItems = [
    { path: "/", label: "Dashboard", permission: "dashboard" },
    { path: "/projects", label: "Projects", permission: "projects:view" },
    { path: "/leads", label: "Leads", permission: "leads:view" },
    { path: "/team", label: "Team", permission: "accounts:view" },
    { path: "/support/dashboard", label: "Support", permission: "support:view" },
    { path: "/settings", label: "Settings", permission: "settings:view" },
    { path: "/knowledge-base", label: "Help Center", permission: "support:view" }
];